<template>
    <div class="record-box">
        <el-button @click="luyin">录音开始</el-button>
        <LuyinBtn />
    </div>
</template>

<script>
    import VConsole from 'vconsole/dist/vconsole.min.js'
    import LuyinBtn from '../main/components/types/components/common/components/luyinBtn'
    export default {
        name: "weixin_record",
        components: {
            LuyinBtn
        },
        created(){
            document.title = '音频录制'
            new VConsole();

            if(typeof(Worker)!=="undefined")
            {
                // 是的! Web worker 支持!
                // 一些代码.....
                alert('支持')
            }
            else
            {
                //抱歉! Web Worker 不支持
                alert('不支持')
            }
        },
        methods: {
            luyin(){
                wx && wx.startRecord();
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>